import { ProposalStatus } from "../types/proposal";

export const PROPOSAL_STATUSES: ProposalStatus[] = [
  "Not started",
  "in progress",
  "primeiro contato",
  "dados recebido",
  "proposta comercial elaborada",
  "link pagamento gerado",
  "pagamento efetuado",
  "envio solicitado",
  "pedido enviado",
  "done",
];

export const DEFAULT_PROPOSAL_STATUS: ProposalStatus = "Not started";
